import React from "react";
import { AppProps } from "single-spa";
import "../../../styles/custom.scss";
import "bootstrap-icons/font/bootstrap-icons.css";
import "font-awesome/css/font-awesome.min.css";
import "icofont/dist/icofont.min.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import SidebarComponent from "../../Sidebar";
import Dashboard from "../Dashboard";
import Orders from "../Orders";
import Summary from "../Summary";
import DynamicOrderForm from "../DynamicOrderForm";
import CelebrationCakeForm from "../CelebrationCakeForm";
import OrderFormRouter from "../OrderFormRouter";
import Login from "../../../pages/Login";
import { AuthProvider } from "../../shared/AuthContext";
import { ProtectedRoute } from "../../shared/ProtectedRoute";
import { routerBasename } from "../../../config/appBasePath";

export const Main: React.FC<AppProps> = (_props: AppProps): JSX.Element => {
  return (
    <Router basename={routerBasename}>
      <AuthProvider>
        <Routes>
          {/* Public Route */}
          <Route path="/login" element={<Login />} />

          {/* Protected Routes */}
          <Route
            path="*"
            element={
              <ProtectedRoute>
                <SidebarComponent>
                  <Routes>
                    <Route
                      path="/"
                      element={<Navigate to="/dashboard" replace />}
                    />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/orders" element={<Orders />} />
                    <Route path="/summary" element={<Summary />} />
                    <Route
                      path="/orders/new/celebration-cake"
                      element={<CelebrationCakeForm />}
                    />
                    <Route
                      path="/orders/new/:type"
                      element={<DynamicOrderForm />}
                    />
                    <Route
                      path="/orders/view/:id"
                      element={<OrderFormRouter />}
                    />
                    <Route
                      path="/orders/edit/:id"
                      element={<OrderFormRouter />}
                    />
                  </Routes>
                </SidebarComponent>
              </ProtectedRoute>
            }
          />

          {/* Standalone Print Route (No Sidebar, still protected) */}
          <Route
            path="/orders/print/:id"
            element={
              <ProtectedRoute>
                <OrderFormRouter />
              </ProtectedRoute>
            }
          />
        </Routes>
      </AuthProvider>
    </Router>
  );
};

